import { ACEPMembershipStatus, ACEPMembershipType, MembershipRate, MembershipStatusReason, SEMPAMembershipStatus, SEMPAMembershipType } from './../../../shared/enums/xrm.constants';
import { Component, OnInit, Input, AfterViewInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { FormGroup, FormArray, Validators } from '@angular/forms';
import { MemberappBaseComponent } from '../groupportal-base/groupportal-base.component';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, Subject, Subscription } from 'rxjs';
import { Group, GroupInfo, AcepContact, SearchContact } from '../../../shared/models/group-portal-data.models';
import { map, share, isEmpty } from "rxjs/operators";
import { MatDatepicker } from "@angular/material/datepicker";
import { Params } from "@angular/router";
import { state } from '@angular/animations';
import * as moment from 'moment';
import { defaultMemberStartDate, defaultMemberEndDate } from '../../../../environments/environment.base';
import { ResidencyDetailsComponent } from '../residency/residency-details.component';
declare var $: any;

@Component({
	selector: 'app-side-nav',
	templateUrl: './side-nav.component.html',
	styleUrls: ['./side-nav.component.scss']
})

export class SideNavComponent extends MemberappBaseComponent {

	@Input() groupList: Group[] = [];
	@Input() searchContactList: SearchContact[] = [];
	@Input() slideOutType: String = '';
	@Input() ui_countries: any = [];
	@Input() ui_stateprovinces: any = [];
	@Input() ui_prefixes: any = [];
	@Input() selectedGroup: Group;
	@Input() npiExist: boolean;
	@Input() slideOutShown: boolean;
	@Input() emailExists: boolean;
	@Input() ui_residencies: any = [];
	@Input() ui_specialities: any = [];
	@ViewChildren(MatDatepicker) datepickers: QueryList<MatDatepicker<Date>>;
	@ViewChild("residencyDetailsComp", { static: false }) residencyDetailsComp: ResidencyDetailsComponent;


	email$ = new Subject<string>();
	npiInvalid: boolean;
	emailInvalid: boolean;
	residencyInvalid: boolean;
	selectedContactDetails: AcepContact;
	selectedContactAddresses: any[];
	eligibleChapters: any = [];
	searchMember: string = '';
	memberList: any;
	showContactForm: boolean;
	showSearchContactList = true;
	showChapterConfirmCheckbox = false;
	chapterChangeCheckBoxSelected: boolean = false;
	newMember: boolean;
	VALIDATE = true;
	formsubmitted: boolean;
	endDateInvalid: boolean;
	validGroup: boolean = false;
	showInvalidResidencyMsg: boolean = false;
	//emailValid: boolean = true;
	http: HttpClient;


	//the foillowing fields are  needed to show customized confirmation messages based on previous member type
	//ACEP
	isCurrentACEPMember: boolean = false;
	isFormerRegularOrResident: boolean = false;
	isFormalMedicalStudent: boolean = false;
	isNeverBeenAnACEPMember: boolean = false;

	//SEMPA
	isCurrentSEMPAFellowMember: boolean = false;
	isFormerSEMPAFellowMember: boolean = false;
	isFormerSEMPAMember: boolean = false;
	isNeverBeenASEMPAMember: boolean = false;

	subscriptions: Array<Subscription> = [];

	get pageValid(): boolean {
		let valid: boolean = !this.emailInvalid;

		if (valid && this.showChapterConfirmCheckbox) {
			valid = this.chapterChangeCheckBoxSelected && !!this.selectedContactDetails.Chapter;
		}

		return valid;
	}

	initSubscriptions() {
		let selectedContactDetailsSubscription: Subscription = this.groupPortalDataService.getSelectedContactDetails().subscribe(selectedContactDetails => { this.updateContactDetails(selectedContactDetails) });
		let selectedContactAddressSubscription: Subscription = this.groupPortalDataService.getSelectedContactAddresses().subscribe(selectedContactAddresses => { this.selectedContactAddresses = selectedContactAddresses });
		//this.groupPortalDataService.getAllMembers().subscribe(allMembers => {this.allMembers = allMembers});
		if (!this.groupPortalDataService.groupList) {
			this.groupPortalDataService.initializeGroupList();
		}
		if (!this.selectedContactDetails) {
			let newContact: AcepContact[] = [];
			this.groupPortalDataService.setSearchContactList(newContact);
		}

		let invalidResidencySubscription: Subscription = this.sideNavService.setInvalidResidency$.subscribe(invalidResidency => {
			console.log(invalidResidency);
			if (invalidResidency) {
				this.showContactForm = false;
				this.showSearchContactList = false;
				this.showInvalidResidencyMsg = true;
			}
		})



		this.subscriptions.push(selectedContactDetailsSubscription);
		this.subscriptions.push(selectedContactAddressSubscription);
		this.subscriptions.push(invalidResidencySubscription);


	}



	resetMembershipFlags() {

		//ACEP
		this.isCurrentACEPMember = false;
		this.isFormerRegularOrResident = false;
		this.isFormalMedicalStudent = false;
		this.isNeverBeenAnACEPMember = false;

		//SEMPA
		this.isCurrentSEMPAFellowMember = false;
		this.isFormerSEMPAFellowMember = false;
		this.isFormerSEMPAMember = false;
		this.isNeverBeenASEMPAMember = false;
	}

	updateContactDetails(selectedContactDetails: AcepContact) {
		this.selectedContactDetails = selectedContactDetails;
		this.refreshStateProvinces();
		this.refreshEligibleChapters();
	}


	DeepCopyObject(oldObj: any) {
		var newObj = oldObj;
		if (oldObj && typeof oldObj === "object") {
			newObj =
				Object.prototype.toString.call(oldObj) === "[object Array]" ? [] : {};
			for (var i in oldObj) {
				newObj[i] = this.DeepCopyObject(oldObj[i]);
			}
		}
		return newObj;
	}



	refreshEligibleChapters() {

		let states = [];
		this.eligibleChapters = [];

		let isAccountEligible = (this.selectedGroup?.accountCategory.indexOf("Physician Group") > -1) && (this.selectedGroup?.accountName.toLowerCase().indexOf('sempa') == -1)
		if (!isAccountEligible) {
			this.showChapterConfirmCheckbox = false;
			this.chapterChangeCheckBoxSelected = false;
			return;
		}


		// if (!!this.selectedContactDetails.Chapter) {
		// 	this.eligibleChapters.push(this.dataService.uidata.Chapters.find(c => c.acep_code == this.selectedContactDetails.Chapter));
		// }

		//Addresses

		let aType = 'Home';
		if (this.selectedContactDetails.AddressType == 2) {
			aType = 'Hospital';
		}
		else if (this.selectedContactDetails.AddressType == 3) {
			aType = 'Business';
		}

		let addrs = this.DeepCopyObject(this.selectedContactAddresses?.filter(a => !!(a.stateOrProvince)));

		if (!!addrs && addrs.length > 0) {

			addrs.find(a => a.addressType == aType).stateOrProvince = this.selectedContactDetails?.State;

			if (addrs?.length > 0) {
				addrs.forEach(a => {
					if (states.indexOf(a.stateOrProvince) == -1) states.push(a.stateOrProvince)
				});

			}
		}


		//chapter
		if (!!this.selectedContactDetails.State) {

			if (states.indexOf(this.selectedContactDetails.State) == -1) {
				states.push(this.selectedContactDetails.State);
			}


		}

		//Medical License
		if (!!this.selectedContactDetails.MedicalLicense) {
			if (states.indexOf(this.selectedContactDetails.MedicalLicense.state) == -1) {
				states.push(this.selectedContactDetails.MedicalLicense.state);
			}
		}

		states = states.sort((one, two) => (one < two ? -1 : 1));

		states.forEach(a => {
			let ch = this.dataService.uidata.Chapters.find(c => c.acep_code == a);
			if (!!ch) {
				this.eligibleChapters.push(ch);
			}

		});

		if (this.eligibleChapters.length == 0) {
			this.showChapterConfirmCheckbox = false;
			this.chapterChangeCheckBoxSelected = false;
		}




	}

	LogItems() {
		console.log("group:", this.selectedGroup, "slideoutType:", this.slideOutType, "contactdeets:", this.selectedContactDetails);
	}
	ngOnInit() {
		const contact = new AcepContact;
		if (!this.selectedContactDetails) {
			this.groupPortalDataService.setEditContactInfo(contact);
		}

		this.LogItems();

		//email duplication check MB 6/13/2019
		this.emailInvalid = false;
		let thisSvc = this;
		if (!!this.email$) {
			this.groupPortalDataService.SearchEmail(this.email$.asObservable())
				//.takeUntil(this.destroy$)
				.subscribe(results => {
					let _emailBelongsToSomeoneElse = thisSvc.groupPortalDataService.emailExists;
					thisSvc.emailInvalid = _emailBelongsToSomeoneElse;

				});
		}

	}
	ngAfterViewInit() {
		//subscriptions start
		//View childs can only be accessible in AfterViewInit life cycle hook
		//residencyDetailsComp
		let thisSvc = this;
		let refreshResidencySubscription: Subscription = this.sideNavService.refreshResidency$.subscribe(refreshResidency => {
			console.log(refreshResidency);
			if (refreshResidency && !!thisSvc.residencyDetailsComp) {
				thisSvc.residencyDetailsComp.selectedContactDetails = this.selectedContactDetails;
				thisSvc.residencyDetailsComp?.setResidency(thisSvc.selectedContactDetails.ACEPID);
			}
		})
		this.subscriptions.push(refreshResidencySubscription);

		//subscriptions end

		this.LogItems();
		if (!this.selectedGroup) {
			if (document.getElementById("mySidepanel").style.visibility !== 'hidden') {
				console.log('footer .contentLoader should not show now.', document.getElementsByClassName("componentLoader").item.length);
			}			
			this.SideNavDisplay('open');
			console.log("opened side nav from after view init");
		}
		console.log('after view init sidenav:', this.groupPortalDataService.groupList.allMembers.length);

		this.datepickers.forEach(datepicker => {
			datepicker.openedStream.subscribe(() => {
				setTimeout(() => {
					if (this.validGroup) {
						const calendarButton = document.querySelector('.mat-focus-indicator.mat-calendar-period-button.mat-button.mat-button-base') as HTMLElement;

						if (calendarButton) {
							calendarButton.style.pointerEvents = 'none';
							calendarButton.setAttribute('disabled', 'true')
						}
					}
				});
			});
		});
	}

	onDatePickerOpened(event: any) {
		if (this.selectedGroup.accountCategory == 'Residency') {
			this.validGroup = true;
		}
		else {
			this.validGroup = false;
		}
	}

	// public openNav() {
	// 	document.getElementById("mySidepanel").style.visibility = "visible";
	// 	document.getElementById("mySidepanel").style.width = "40vw";
	// 	document.getElementById("mySidepanel").style.height = "100vh";

	// 	// document.getElementById("allspelements").style.visibility = "visible";
	// 	//document.getElementById("sidebar").style.width = "40vw";
	// 	//document.getElementById("sidebar").style.height = "100vw";
	// 	//document.getElementById("sidebar").style.visibility = "visible";

	//   }

	// public closeNav() {
	// 	document.getElementById("mySidepanel").style.width = "0";
	// 	document.getElementById("mySidepanel").style.visibility = "hidden";
	// 	// document.getElementById("allspelements").style.visibility = "hidden";
	// 	//document.getElementById("sidebar").style.visibility = "hidden";
	// 	//document.getElementById("sidebar").style.width = "0";
	//   }

	onCountrySelect(countrycode) {
		this.refreshStateProvinces();
		this.selectedContactDetails.Chapter = "";
	}

	onStateSelect() {
		this.refreshEligibleChapters();
		this.selectedContactDetails.Chapter = "";
	}

	onChapterSelect() {
		this.showChapterConfirmCheckbox = true;
	}

	refreshStateProvinces() {
		//debugger;
		if (this.dataService.uidata) {
			this.ui_stateprovinces = this.dataService.uidata.StateProvinces.filter(
				s => s.countrycode === this.selectedContactDetails.Country
			);
		}
		if (!this.selectedContactDetails.State || this.groupPortalDataService.findObjectByKey(this.ui_stateprovinces, 'acep_isocode', this.selectedContactDetails.State)?.length < 1) {
			this.selectedContactDetails.State = "";
		}
	}

	navigateToRoute(routeName) {
		this.slideOutShown = false;
		this.slideOutBlur();
		//this.activateLeftNavGrpBtn(routeName);
		$('ul li.active.route').removeClass('active route');
		$('ul li button#' + routeName).parent().addClass('active route');
		this.groupPortalDataService.navigateToRoute(routeName, true, this.selectedGroup.acepId);
	}

	showSlideOut(clickeditem) {
		this.showContactForm = false;
		this.searchMember = '';

		this.groupPortalDataService.resetSearchContactList();
		this.groupPortalDataService.SetSlideOutType(clickeditem);

		$('#GPsidenav ul li.active.slideOutShow').removeClass('active slideOutShow'); //removes previous selection
		$('ul li button#' + clickeditem).parent().addClass('active slideOutShow'); //activates newly clicked item
		//$('nav#sidebar.noseeme').removeClass('noseeme');
		//$('nav#sidebar').addClass('animate-LTR');
		//$('nav#sidebar').attr('style', 'height: ' + $(document).height() + 'px; margin-left: 0px; margin-bottom: 10px;');		
		this.SideNavDisplay('open');
		//$('nav#sidebar').attr('style', 'height: ' + $(document).height() + 'px; left: 75px; top: 0; position:absolute; animation: animateleft 0.4s; z-index:20;');
		$('.body-content').attr('style', 'background-color: rgba(255,255,255,0.2);');
	}

	slideOutBlur() {
		this.slideOutShown = false;
		this.groupPortalDataService.scrollToTop();
		this.hideSuccessMsg();
		this.npiExist = false;
		this.npiInvalid = false;
		this.emailInvalid = false;
		this.emailExists = false;
		//$('nav#sidebar').addClass('noseeme');
		//$('nav#sidebar').addClass('animate-RTL');
		//this.closeNav();
		this.SideNavDisplay('close');
		//$('nav#sidebar').attr('style', 'position:absolute; animation: animateright 0.4s; right:101%; z-index: -1; ');
		$('#GPsidenav ul li.active.slideOutShow').removeClass('active slideOutShow');

	}

	setshowContactForm(acepId, show) {

		this.residencyDetailsComp?.setResidency(acepId);
		this.formsubmitted = false;
		this.resetMembershipFlags();


		this.groupPortalDataService.scrollToTop();
		if (acepId !== 0) {
			this.newMember = false;
			let groupMember = this.groupPortalDataService.findObjectByKey(this.groupPortalDataService.groupList.allMembers, 'contactNo', acepId);
			if (!groupMember) {
				this.groupPortalDataService.getEditContactInfo(acepId);

			} else {
				this.groupPortalDataService.getEditContactInfo(acepId, true, groupMember);
				let editconfirmmodal = $("[data-remodal-id=editMemberContact]").remodal();
				editconfirmmodal.open();
				return false;
			}
		} else {
			this.newMember = true;
			var contactDetails = new AcepContact;
			contactDetails.Country = 'US';
			this.groupPortalDataService.setEditContactInfo(contactDetails);
			this.groupPortalDataService.resetSearchContactList();
			this.eligibleChapters = [];
			this.selectedContactAddresses = [];
			this.showChapterConfirmCheckbox = false;

		}
		this.searchMember = '';
		this.showContactForm = show;
	}

	changeContactAddress() {
		let contactAddress = [];
		let selectedContact = this.selectedContactDetails;
		let addressTypeExists = false;
		contactAddress = this.selectedContactAddresses;
		if (contactAddress) {
			for (var i = 0; i < contactAddress.length; i++) {

				if (this.getAddressType(contactAddress[i].addressType) === this.selectedContactDetails.AddressType) {
					addressTypeExists = true;
					selectedContact = this.groupPortalDataService.setSelectedContactDetailsAddress(contactAddress[i], selectedContact);
				}
			}
		}
		if (!addressTypeExists) {
			selectedContact = this.groupPortalDataService.setSelectedContactDetailsAddress([], selectedContact, true);
		}

		this.refreshStateProvinces();
	}

	getAddressType(type) {
		let addressType = '1';
		switch (type) {
			case "Home": {
				addressType = '1';
				break;
			}
			case "Hospital": {
				addressType = '2';
				break;
			}
			case "Business": {
				addressType = '3';
				break;
			}
			default: {
				addressType = '1'
			}
		}
		return addressType;
	}
	returnToSearch() {
		this.groupPortalDataService.scrollToTop();
		this.hideSuccessMsg();
		this.showContactForm = false;
	}

	hideSuccessMsg() {
		let selectedContact = this.selectedContactDetails;

		selectedContact.residency.id = '';
		selectedContact.residency.specialityId = '';
		selectedContact.residency.gradYear = '';

		selectedContact.showSuccessMsg = false;
		this.showSearchContactList = true;
		this.showInvalidResidencyMsg = false;

		this.groupPortalDataService.setEditContactInfo(selectedContact);
	}
	searchForMembers() {
		this.showContactForm = false;
		this.showSearchContactList = true;
		if (this.searchMember.length > 2) {
			this.groupPortalDataService.searchForContact(this.searchMember);
		} else {
			this.groupPortalDataService.resetSearchContactList();
		}
	}

	checkIfEmailExists() {
		this.emailInvalid = true;
		this.groupPortalDataService.userExistsByEmail(this.selectedContactDetails.EmailAddress, this.selectedContactDetails.ACEPID);
	}

	updateMembershipFlags(d: any) {

		let isSEMPA = this.groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid == 'Yes';

		if (!isSEMPA) {
			//d.acepMemberStatus d.acepMemberType d.acepMemberRate
			let isCancelled = (d.acepMemberStatus == ACEPMembershipStatus.Cancelled);
			this.isFormalMedicalStudent = isCancelled && d.acepMemberType == ACEPMembershipType.Candidate && d.acepMemberRate == MembershipRate.MedStu;
			this.isNeverBeenAnACEPMember = d.acepMemberStatus == 0;
		}
		else {
			//SEMPA
			//d.sempaMemberStatus d.sempaMemberType d.sempaMemberRate
			//https://jira.acep.org/browse/GROUPPORTAL-781
			let isCancelled = (d.sempaMemberStatus == SEMPAMembershipStatus.Cancelled) && (d.sempaMemberType != SEMPAMembershipType.Fellow);

			this.isFormerSEMPAMember = isCancelled;
			this.isNeverBeenASEMPAMember = d.sempaMemberStatus == 0;


		}

	}

	addMemberToGroup(newMember, leadershipOnly = false) {

		//reset membership flags
		this.resetMembershipFlags();


		this.groupPortalDataService.scrollToTop();
		if (!this.isFormValid()) {
			return false;
		}
		//AkshayG:This is setting the groupBilling flag always true. so commenting it out.	
		//this.selectedContactDetails.groupBilling = this.groupPortalDataService.inGroupBilling;
		if (newMember || leadershipOnly) {
			if (leadershipOnly) {
				this.selectedContactDetails.groupBilling = false;
			}
			if (this.groupPortalDataService.emailExists) {
				this.groupPortalDataService.searchForContact(this.selectedContactDetails.EmailAddress, false, true, this.selectedContactDetails);
			} else if (this.groupPortalDataService.npiExists) {
				this.groupPortalDataService.searchForContact(this.selectedContactDetails.NPINumber, true, true, this.selectedContactDetails);
			} else {
				this.groupPortalDataService.CreateContact(this.selectedContactDetails, leadershipOnly);
			}
		} else {


			//call getcontactdetailsbyid end point to get all membership details .as profile api does not give cancelled membership details

			this.groupPortalDataService.GetContactDetailsById(this.selectedContactDetails.ACEPID).subscribe((d: any) => {

				//update the following variables here.....
				this.updateMembershipFlags(d);
				this.groupPortalDataService.addMemberToGroup(this.selectedContactDetails);

			})

		}
		this.formsubmitted = false;
		this.showContactForm = false;

	}

	cancelEdit() {
		this.slideOutShown = false;
		this.slideOutBlur();
	}

	editContact() {
		if (!this.isFormValid()) {
			return false;
		}
		this.groupPortalDataService.updateContact(this.selectedContactDetails);
		this.formsubmitted = false;
		this.slideOutShown = false;
		this.slideOutBlur();
	}

	openContactEdit() {
		this.residencyDetailsComp?.setResidency(this.selectedContactDetails.ACEPID);
		this.searchMember = '';
		this.showContactForm = true;
		this.groupPortalDataService.SetSlideOutType("editMember");
		let editconfirmmodal = $("[data-remodal-id=editMemberContact]").remodal();
		editconfirmmodal.close();
	}

	closeModal() {
		let editconfirmmodal = $("[data-remodal-id=editMemberContact]").remodal();
		editconfirmmodal.close();
	}

	isFormValid() {
		this.formsubmitted = true;
		let regexNPI = /^[0-9]{10}$/;
		let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
		let validNPI = this.selectedContactDetails.NPINumber ? this.selectedContactDetails.NPINumber.match(regexNPI) :
			(this.groupPortalDataService.groupList.GroupInfo.residencyDetail || this.groupPortalDataService.groupList.GroupInfo.physgrpDetail.sempaDuesPaid === 'Yes' ? true : false);
		let validEmail = this.selectedContactDetails.EmailAddress.match(regexEmail);
		if (!validNPI) {
			if (this.selectedContactDetails.NPINumber) {
				this.npiInvalid = true;
				this.npiExist = false;
			} else {
				this.npiInvalid = false;
			}
		} else {
			this.npiInvalid = false;
		}
		if (!validEmail) {
			if (this.selectedContactDetails.EmailAddress) {
				this.emailInvalid = true;
			} else {
				this.emailInvalid = false;
			}
		} else {
			this.emailInvalid = false;
		}

		let isNotAddLeadershipPane = this.slideOutType !== 'addLeadership';

		let commonValidationConditions =
			!this.selectedContactDetails.FirstName ||
			!this.selectedContactDetails.LastName ||
			!this.selectedContactDetails.EmailAddress ||
			this.npiInvalid ||
			this.emailInvalid ||
			(isNotAddLeadershipPane &&
				((!this.selectedContactDetails.NPINumber &&
					!this.groupPortalDataService.groupList.GroupInfo.residencyDetail &&
					this.groupPortalDataService.groupList.GroupInfo.physgrpDetail &&
					this.groupPortalDataService.groupList.GroupInfo.physgrpDetail
						.sempaDuesPaid !== "Yes") ||
					!this.selectedContactDetails.Country ||
					!this.selectedContactDetails.Street ||
					!this.selectedContactDetails.City ||
					(!this.selectedContactDetails.State &&
						(this.selectedContactDetails.Country === "CA" ||
							this.selectedContactDetails.Country === "US")) ||
					this.emailExists ||
					!this.selectedContactDetails.Phone ||
					!this.selectedContactDetails.startDate ||
					(this.selectedContactDetails.endDate && this.compareEndDate())));


		let physicianGroupResidencyValidationConditions = !this.selectedContactDetails.residency.id
			|| !this.selectedContactDetails.residency.specialityId
			|| (!this.selectedContactDetails.residency.gradYear || this.selectedContactDetails.residency.gradYear == '0')


		if (this.selectedGroup.accountCategory == 'Physician Group') {
			if ((commonValidationConditions && this.groupPortalDataService.groupList.GroupInfo.physgrpDetail) || physicianGroupResidencyValidationConditions)
				return false;
		}
		else {
			if (commonValidationConditions && this.groupPortalDataService.groupList.GroupInfo.residencyDetail)
				return false;
		}
		return true;
	}

	selectGroup(accountId) {
		this.slideOutShown = false;
		this.slideOutBlur();
		this.groupPortalDataService.showGroupInfo = false;
		const newAccount = (accountId !== this.groupPortalDataService.groupList.groupNumber);
		this.groupPortalDataService.SetSelectedGroup(accountId);
		this.groupPortalDataService.SetGroupNumber(accountId);
		this.groupPortalDataService.callGroupAPIs(newAccount);
		$('ul li.active.route').removeClass('active route');
		$('ul li button#dashboard').parent().addClass('active route');
		this.groupPortalDataService.navigateToRoute('dashboard', true, accountId);
	}

	checkIfEndDateValid() {

		if (this.selectedContactDetails.endDate && this.selectedContactDetails.startDate && this.selectedContactDetails.endDate < this.selectedContactDetails.startDate) {
			this.endDateInvalid = true;
		} else {
			this.endDateInvalid = false;
		}
	}


	handleYearSelected(selectedYear: moment.Moment, datepicker: MatDatepicker<any>, type: string) {
		if (type == 'start') {
			const startDateString = `${defaultMemberStartDate}${selectedYear.year()}`;
			this.selectedContactDetails.startDate = moment(startDateString).format('YYYY-MM-DD');
		} else {
			const endDateString = `${defaultMemberEndDate}${selectedYear.year()}`;
			this.selectedContactDetails.endDate = moment(endDateString).format('YYYY-MM-DD');
		}
		// Close the date picker
		datepicker.close();
	}

	compareToCycleStartDate() {
		if (this.groupPortalDataService.groupList && this.groupPortalDataService.groupList.GroupInfo &&
			this.groupPortalDataService.groupList.GroupInfo.residencyDetail) {
			return new Date(this.selectedContactDetails.endDate) > new Date(this.groupPortalDataService.groupList.GroupInfo.residencyDetail.cycleStartDate)
		}
		return true;
	}

	compareEndDate() {
		if (this.selectedContactDetails.endDate && new Date(this.selectedContactDetails.endDate) < new Date(this.selectedContactDetails.startDate)) {
			return true;
		}
		else {
			return false;
		}
	}

	searchForContactByNPI() {
		let regex = /^[0-9]{10}$/;
		let validNPI = this.selectedContactDetails.NPINumber.match(regex);
		if (!validNPI) {
			if (this.selectedContactDetails.NPINumber) {
				this.npiInvalid = true;
			} else {
				this.npiInvalid = false;
			}
			this.npiExist = false;
			return true;
		} else {
			this.npiInvalid = false;
		}
		if (this.selectedContactDetails.NPINumber === "" || this.selectedContactDetails.NPINumber.length < 10) {
			this.npiExist = false;
			return true;
		} else {
			this.groupPortalDataService.searchForContact(this.selectedContactDetails.NPINumber, true);
		}
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscriptions.forEach((subscription: Subscription) => {
			subscription.unsubscribe();
		});
	}
}
